@if (display) {
  <div #dropdownContainer  [style.transform]="'translate(' + this.translationX + 'px)'" class="dropdown-container" [class.open-above]="openAbove" @in-out-animation [@.disabled]="!animate"  (@in-out-animation.start)="onAnimationStart($event)" >
    @if (arrow) {
      <div class="dropdown-arrow-top" [style.transform]="'translate(' + -(this.translationX) + 'px) rotate(45deg)'" [style.left]="arrowPosition + 'px'"></div>
    }
    <div class="dropdown-inner-container" [style.border-radius.px]="radius" [style.padding-left.px]="paddingX" [style.padding-right.px]="paddingX" [style.padding-top.px]="paddingY" [style.padding-bottom.px]="paddingY">
      <ng-content>
      </ng-content>
    </div>
  </div>
}
